<template>
  <div class="Sidementoggle" @click="toggleSidebar">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="M4 6a.75.75 0 0 1 .75-.75h14.5a.75.75 0 0 1 0 1.5H4.75A.75.75 0 0 1 4 6Zm0 6a.75.75 0 0 1 .75-.75h14.5a.75.75 0 0 1 0 1.5H4.75A.75.75 0 0 1 4 12Zm.75 5.25a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 0-1.5H4.75Z"
      ></path>
    </svg>
  </div>
  <div class="iq-sidebar sidebar-default cmn-sidebar-wrapper">
    <div class="iq-sidebar-logo">
      <router-link to="/" class="header-logo" exact>
        <!-- <img src="../../assets/images/logo.png" class="img-fluid rounded-normal light-logo" :class="$store.state.isDarkMode?'d-none':''"  alt="logo">
                        <img src="../../assets/images/logo-white.png" class="img-fluid rounded-normal darkmode-logo" :class="$store.state.isDarkMode?'':'d-none'"   alt="logo"> -->
        <img
          src="../../assets/images/dashboard/dash-logo.svg"
          class="img-fluid rounded-normal light-logo"
          alt="logo"
        />
      </router-link>
      <div class="iq-menu-bt-sidebar">
        <span class="wrapper-menu close-sidebar-icon">
          <svg
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0 15C0 6.71574 6.71575 0 15.0001 0C23.2843 0 30 6.71574 30 15C30 23.2841 23.2843 30 15.0001 30C6.71575 30 0 23.2841 0 15ZM15.0001 2.15164C7.90408 2.15164 2.15167 7.90406 2.15167 15C2.15167 22.096 7.90408 27.8484 15.0001 27.8484C22.096 27.8484 27.8483 22.096 27.8483 15C27.8483 7.90406 22.096 2.15164 15.0001 2.15164ZM20.3309 9.66972C20.773 10.112 20.773 10.829 20.3309 11.2713L16.6018 15.0003L20.3309 18.7293C20.773 19.1715 20.773 19.8886 20.3309 20.3308C19.8886 20.773 19.1716 20.773 18.7293 20.3308L15.0003 16.6018L11.2713 20.3308C10.829 20.773 10.112 20.773 9.66975 20.3308C9.2275 19.8886 9.2275 19.1715 9.66975 18.7293L13.3988 15.0003L9.66975 11.2713C9.2275 10.829 9.2275 10.112 9.66975 9.66972C10.112 9.22748 10.829 9.22748 11.2713 9.66972L15.0003 13.3988L18.7293 9.66972C19.1716 9.22748 19.8886 9.22748 20.3309 9.66972Z"
              fill="currentColor"
            />
          </svg>
        </span>
      </div>
    </div>
    <div class="data-scrollbar" data-scroll="1" data-simplebar>
      <div
        class="sidebar-content-wrap new-create select-dropdown input-prepend input-append"
      >
        <!-- Trigger Button -->
        <div class="btn-group" ref="dropdownTrigger">
          <!-- <div class="search-query selet-caption" @click="toggleDropdown"> -->
          <div class="search-query selet-caption" @click="toggleDropdown">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <path
                fill="currentColor"
                d="M12.75 11.25V5a.75.75 0 1 0-1.5 0v6.25H5a.75.75 0 1 0 0 1.5h6.25V19a.75.75 0 1 0 1.5 0v-6.25H19a.75.75 0 1 0 0-1.5h-6.25z"
              ></path>
            </svg>
          </div>
        </div>
        <a
          class="d-none fileFoldeCls"
          data-toggle="modal"
          data-target="#fileAndFolderModals"
        ></a>
      </div>
      <nav class="iq-sidebar-menu">
        <ul id="iq-sidebar-toggle" class="iq-menu">
          <li :class="{ active: $route.path === '/' }">
            <router-link to="/" class="" exact>
              <i>
                <MyDriveSvg />
              </i>
              <span>My Drive</span>
            </router-link>
          </li>
          <li :class="{ active: $route.path === '/starred' }">
            <router-link to="/starred" class="" exact>
              <i>
                <StarredSvg />
              </i>
              <span>Starred</span>
            </router-link>
          </li>
          <li :class="{ active: $route.path === '/shared-with-me' }">
            <router-link to="/shared-with-me" class="" exact>
              <i>
                <SharedWithMeSvg />
              </i>
              <span>Shared</span>
            </router-link>
          </li>
          <li
            :class="[
              { active: $route.path === '/trash' },
            ]"
          >
              <!-- $store.state.user.userInfo.role_name === 'user' ? 'd-none' : '', -->
            <router-link to="/trash" class="" exact>
              <i>
                <TrashSvg />
              </i>
              <span>Trash</span>
            </router-link>
          </li>
          <li 
            :class="[
              { active: $route.path === '/users' },
              $store.state.user.userInfo.role_name === 'user' ? 'd-none' : '',
            ]"
          
          >
            <router-link to="/users" class="" exact>
              <i>
                <UsersSvg />
              </i>
              <span>Users</span>
            </router-link>
          </li>
          <li class="d-none">
            <a href="javascript:;" class="">
              <i>
                <SettingSvg />
              </i>
              <span>Settings</span>
            </a>
          </li>
          <li>
            <a href="javascript:;" class="" v-on:click="profileModal()">
              <i>
                <ProfileSvg />
              </i>
              <span>Profile</span>
            </a>
          </li>
          <li data-toggle="modal" data-target="#logoutModals">
            <a href="javascript:;" class="">
              <i>
                <SignOutSvg />
              </i>
              <span>Sign Out</span>
            </a>
          </li>
        </ul>
      </nav>
      <div class="p-3"></div>
    </div>
  </div>
  <div
    class="modal fade"
    id="logoutModals"
    tabindex="-1"
    style="display: none"
    aria-hidden="true"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    aria-labelledby="staticBackdropLabel"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Confirm Change?</h5>
        </div>
        <div class="modal-body">
          <div class="col-12 text-center">
            <label for="bankName" class="form-label mb-0"
              >Are you sure you want to logout?</label
            >
          </div>
        </div>
        <div class="modal-footer">
          <button variant="success" class="btn btn-primary" v-on:click="logout()">
            Yes
          </button>
          <button
            variant="outline-primary"
            class="btn btn-secondary"
            id="closeBtn"
            data-dismiss="modal"
          >
            No
          </button>
        </div>
      </div>
    </div>
  </div>
  <div
    class="modal fade FoldersetModal"
    id="fileAndFolderModals"
    tabindex="-1"
    style="display: none"
    aria-hidden="true"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    aria-labelledby="staticBackdropLabel"
  >
    <button
      type="button"
      class="d-none"
      id="FolderModalCloseBtn"
      data-dismiss="modal"
      aria-label="Close"
    >
      <span aria-hidden="true">×</span>
    </button>
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <ul class="floating_menucls">
          <li>
            <div class="item" v-on:click="createFolderFromParent()">
              <FolderSvg />New Folder
            </div>
          </li>
          <!-- <li>
                        <div class="item" v-on:click="createFileFromParent()">
                            <FileSvg />Upload Files
                        </div>
                    </li> -->
          <li>
            <div class="item" v-on:click="uploadFilesTest()"><FileSvg />Upload Files</div>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <!-- Hidden file input for TEST functionality -->
  <input
    type="file"
    ref="fileInput"
    multiple
    accept="image/*,application/pdf,application/zip,application/x-zip-compressed,application/x-rar-compressed,video/*,audio/*,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation"
    style="display: none"
    @change="handleFileSelect"
  />
  <!-- DragDrop-like upload progress card -->
  <div
    class="uploadfiles_css"
    v-if="showUploadSuccess || uploading || files.length"
    style="z-index: 9999"
  >
    <h4>
      <template v-if="uploading"
        >Uploading {{ files.length }} item{{ files.length > 1 ? "s" : "" }}</template
      >
      <template v-else-if="uploadSuccessFiles.length">
        {{ uploadSuccessFiles.length }} upload{{
          uploadSuccessFiles.length > 1 ? "s" : ""
        }}
        complete
      </template>
    </h4>

    <ul v-if="uploadSuccessFiles.length" class="upload-successx upload-data successclsd">
      <li v-for="(file, index) in uploadSuccessFiles" :key="index">
        {{ file }}
        <svg
          class="a-s-fa-Ha-pa c-qd"
          width="24px"
          height="24px"
          viewBox="0 0 24 24"
          fill="#0F9D58"
        >
          <path
            d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
          />
        </svg>
      </li>
    </ul>

    <ul v-if="files.length" class="upload-data">
      <li v-for="(file, index) in files" :key="index">
        {{ file.name }} ({{ file.type || formatFileSize(file.size) }}) -
        <span class="custom-spinner"></span>
      </li>
    </ul>
  </div>

  <CreateFolderData ref="folderModalRef" />
  <CreateFileData ref="fileModalRef" />
  <Profile ref="profileModalRef" />
</template>

<script>
import CreateFolderData from "../../components/Folder/CreateFolder.vue";
import CreateFileData from "../../components/Folder/CreateFile.vue";
import TrashSvg from "@/components/Widgets/Icon/Trash.vue";
import UsersSvg from "@/components/Widgets/Icon/Users.vue";
import ProfileSvg from "@/components/Widgets/Icon/Profile.vue";
import StarredSvg from "@/components/Widgets/Icon/Starred.vue";
import SharedWithMeSvg from "@/components/Widgets/Icon/SharedWithMe.vue";
import SettingSvg from "@/components/Widgets/Icon/Setting.vue";
import MyDriveSvg from "@/components/Widgets/Icon/MyDrive.vue";
import SignOutSvg from "@/components/Widgets/Icon/SignOut.vue";
import FolderSvg from "@/components/Widgets/Icon/Folder.vue";
import FileSvg from "@/components/Widgets/Icon/File.vue";
import Profile from "@/components/Users/Profile.vue";
import axios from "axios";
import { decodeTextFromBase62, encodeTextToBase62 } from "../../utils/helper.js";
import $ from "jquery";
export default {
  name: "SideLayout",
  components: {
    CreateFolderData,
    CreateFileData,
    TrashSvg,
    UsersSvg,
    ProfileSvg,
    StarredSvg,
    SharedWithMeSvg,
    SettingSvg,
    MyDriveSvg,
    SignOutSvg,
    FolderSvg,
    FileSvg,
    Profile,
  },
  data() {
    return {
      showDropdown: false,
      dropdownStyle: {
        position: "absolute",
        top: "0px",
        left: "0px",
        display: "none",
        zIndex: 9999,
        backgroundColor: "#fff",
        border: "1px solid #ccc",
        padding: "10px",
        borderRadius: "4px",
      },
      isSidebarOpen: false,
      // Upload functionality data (DragDrop-like)
      files: [],
      uploadSuccessFiles: [],
      uploading: false,
      showUploadSuccess: false,
      successTimer: null,
    };
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  methods: {
    encodeTextToBase62,
    decodeTextFromBase62,

    toggleDropdown() {
      $(".fileFoldeCls").trigger("click");
    },
    hideDropdown() {
      this.showDropdown = false;
      this.dropdownStyle.display = "none";
    },
    handleClickOutside(event) {
      const trigger = this.$refs.dropdownTrigger;
      const menu = this.$refs.dropdownMenu;

      if (!trigger.contains(event.target) && (!menu || !menu.contains(event.target))) {
        this.hideDropdown();
      }
    },
    async logout() {
      document.getElementById("closeBtn").click();
      this.$store.state.user.accessToken = "";
      this.$store.state.isActiveToken = "";
      this.$store.state.user.userInfo = "";
      localStorage.removeItem("userInfo");
      localStorage.removeItem("mDrivetoken");

      this.$store.commit("resetState");
      this.$store.commit("home/resetState");
      this.$store.commit("trash/resetState");
      this.$store.commit("starred/resetState");
      this.$router.push({
        name: "Login",
      });
    },
    async createFolderFromParent() {
      document.getElementById("FolderModalCloseBtn").click();
      this.hideDropdown();
      this.$refs.folderModalRef.createFolder();
    },
    async createFileFromParent() {
      document.getElementById("FolderModalCloseBtn").click();
      this.hideDropdown();
      this.$refs.fileModalRef.createFile();
    },
    async profileModal() {
      this.$refs.profileModalRef.profileUpdate();
    },
    toggleSidebar() {
      const sidebar = document.querySelector("body");
      if (sidebar) {
        sidebar.classList.toggle("sidebar-collapsed");
      }
    },

    // Step 1: Open file dialog when clicking "Upload Files TEST"
    uploadFilesTest() {
      document.getElementById("FolderModalCloseBtn").click();
      this.hideDropdown();
      this.$refs.fileInput.click();
    },

    // Step 2: Handle file selection
    handleFileSelect(event) {
      const selectedFiles = Array.from(event.target.files);
      if (selectedFiles.length > 0) {
        this.files = selectedFiles;
        this.fileUpload();
      }
      event.target.value = "";
    },

    // DragDrop-like upload implementation
    async fileUpload() {
      if (this.uploading) return;

      // Resolve folder path
      let folderPath = "";
      if (this.$route.query.path && this.$route.query.path.trim() !== "") {
        const pathSegments = this.$route.query.path.split("/");
        folderPath = pathSegments
          .map((segment) => this.decodeTextFromBase62(segment))
          .join("/");
      }
      if (folderPath === "/") folderPath = "";

      this.uploading = true;
      this.showUploadSuccess = false;
      clearTimeout(this.successTimer);

      while (this.files.length > 0) {
        const file = this.files[0];
        try {
          const formData = new FormData();
          formData.append("file", file);
          formData.append("folderName", folderPath);

          const resp = await axios.post(
            process.env.VUE_APP_API_URL + "files/upload-to-folder",
            formData,
            { headers: { "Content-Type": "multipart/form-data" } }
          );

          if (resp.status === 200 && resp.data.status === "success") {
            this.$toast.success(resp.data.message);
            if (!this.uploadSuccessFiles.includes(file.name)) {
              this.uploadSuccessFiles.push(file.name);
            }
          } else {
            console.error(resp.data.message || "Upload failed");
          }
        } catch (e) {
          console.error(`Error uploading ${file.name}:`, e);
        }

        this.files.shift();
      }

      this.uploading = false;
      this.showUploadSuccess = true;
      this.$store.state.home.reLoadFilecomponent = Math.random();

      this.successTimer = setTimeout(() => {
        this.showUploadSuccess = false;
        this.uploadSuccessFiles = [];
      }, 30000);
    },

    cancelUpload() {
      this.files = [];
      this.uploading = false;
      this.showUploadSuccess = false;
      this.uploadSuccessFiles = [];
      clearTimeout(this.successTimer);
    },

    // Format file size
    formatFileSize(bytes) {
      if (bytes === 0) return "0 Bytes";
      const k = 1024;
      const sizes = ["Bytes", "KB", "MB", "GB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
    },
  },
};
</script>

<script setup>
import { onMounted } from "vue";
import SimpleBar from "simplebar";
import "simplebar/dist/simplebar.css";

onMounted(() => {
  new SimpleBar(document.querySelector(".data-scrollbar"));
});
</script>
<style scoped>
.btn-group {
  display: inline-block;
  cursor: pointer;
}

.dropdown-menu {
  list-style: none;
  margin: 0;
  padding: 0;
  min-width: 150px;
}

.dropdown-menu .item {
  padding: 8px 12px;
  cursor: pointer;
}

.dropdown-menu .item:hover {
  background-color: #f0f0f0;
}

/* Upload Progress Styles */
.upload-progress-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.upload-progress-modal {
  background: white;
  border-radius: 8px;
  padding: 20px;
  min-width: 400px;
  max-width: 600px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

.upload-progress-header {
  border-bottom: 1px solid #eee;
  padding-bottom: 15px;
  margin-bottom: 15px;
}

.upload-progress-header h4 {
  margin: 0;
  color: #333;
}

.upload-progress-content {
  max-height: 300px;
  overflow-y: auto;
}

.file-upload-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #f0f0f0;
}

.file-info {
  flex: 1;
}

.file-name {
  font-weight: 500;
  color: #333;
}

.file-size {
  color: #666;
  font-size: 0.9em;
  margin-left: 5px;
}

.upload-status {
  margin-left: 15px;
}

.spinner {
  width: 20px;
  height: 20px;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.success-icon {
  color: #28a745;
  font-weight: bold;
  font-size: 18px;
}

.error-icon {
  color: #dc3545;
  font-weight: bold;
  font-size: 18px;
}

.upload-progress-footer {
  margin-top: 15px;
  text-align: right;
}

.cancel-btn {
  background: #6c757d;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
}

.cancel-btn:hover {
  background: #5a6268;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
/* spinner reused for list */
.custom-spinner {
  display: inline-block;
  width: 1rem;
  height: 1rem;
  border: 2px solid #ccc;
  border-top-color: #007bff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  vertical-align: middle;
  margin-left: 6px;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
